import type { ReadonlyNonEmptyArray } from '../../../../../../utils'

import { areCybusMappingEquals, Capability, type StatusType } from '../../../../../../domain'

import type { PageSubscriptionsTypes, SubscriptionFilterArgs } from '../../../../../../application'

import type { Resource } from '../../../../mappers'
import {
    type AllResourcesRequestConfig,
    BaseStatefulPageResourceSubscriptionStrategy,
    type PageResourceSortableColumnsMap,
    type ServiceResourcesRequestConfig,
} from '../Resource'
import { mapBaseMapping } from './Base'

export class MappingsStrategy extends BaseStatefulPageResourceSubscriptionStrategy<'Mapping', 'mappings'> {
    protected override readonly supportedFilters: (keyof SubscriptionFilterArgs)[] = ['service']

    protected override readonly areEquals = areCybusMappingEquals

    protected readonly serviceResourcesRequestConfig: ServiceResourcesRequestConfig<'mappings'> = {
        capability: Capability.MAPPINGS_READ,
        path: '/api/v2/services/+/resources',
        method: 'GET',
    }

    protected override readonly allResourcesRequestConfig: AllResourcesRequestConfig<'mappings'> = {
        capability: Capability.MAPPINGS_READ,
        path: '/api/v2/resources',
        method: 'GET',
    }

    protected override readonly resourceCategories: ReadonlyNonEmptyArray<'Mapping'> = ['Mapping']

    protected override readonly resourceStatusType = 'mappings' as const

    protected override readonly serviceDeviationsType = ['mappings', 'mappings'] as const

    protected override readonly serverErrorMessage = 'Could not fetch mappings'

    protected sortingColumns: PageResourceSortableColumnsMap<'mappings'> = {
        service: 'serviceId',
        id: 'resourceId',
        name: 'resourceName',
        status: null,
        agent: 'runnerName',
        entriesCount: null,
    }

    override readonly requiredPermissions = [Capability.MAPPINGS_READ]

    // eslint-disable-next-line class-methods-use-this
    protected override mapResource (resource: Resource<'Mapping'>, status: StatusType): PageSubscriptionsTypes['mappings'] {
        return { ...mapBaseMapping(resource), entriesCount: resource.resourceConfig.args.mappings.length, status }
    }
}
